module.exports = __webpack_public_path__ + "img/icon_j2.4d57d39.png";